import { useState } from "react";
import styled from "styled-components";
import CheckedImage from "../Images/checkbox_checked.svg";
import UncheckedImage from "../Images/checkbox_unchecked.svg";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";

const CheckBox = ({ title, options, onChange, initialOption }) => {
  const [selectedOptions, setSelectedOptions] = useState(initialOption);
  const numArr = [1, 2, 3, 4, 5, 6, 7];

  const handleCheckBoxChange = (option) => {
    let updatedOptions;
    if (selectedOptions.includes(option)) {
      updatedOptions = selectedOptions.filter((item) => item !== option);
    } else {
      updatedOptions = [...selectedOptions, option];
    }

    setSelectedOptions(updatedOptions);

    const updatedIndex = updatedOptions.map(
      (item) => options.indexOf(item) + 1
    );
    onChange(updatedIndex);
  };

  return (
    <Container>
      <p className="medium-text">{title}</p>

      <div className="hrz-wrapper" style={{ marginTop: "14px" }}>
        {options.map((option) => (
          <label key={option} className="checkbox-label">
            <input
              type="checkbox"
              value={option}
              checked={selectedOptions.includes(option)}
              onChange={() => {
                handleCheckBoxChange(option);
              }}
            />
            <span className="custom-checkbox"></span>
            {option}
          </label>
        ))}
      </div>
    </Container>
  );
};

const Container = styled.div`
  .checkbox-label {
    display: flex;
    align-items: center;
    margin-right: 32px;
    cursor: pointer;
  }
  .checkbox-label input[type="checkbox"] {
    display: none;
  }

  .custom-checkbox {
    width: 20px;
    height: 20px;
    background-image: url(${UncheckedImage});
    margin-right: 7px;
  }

  .checkbox-label input[type="checkbox"]:checked + .custom-checkbox {
    background-size: cover;
    margin-top: -1px;
    background-image: url(${CheckedImage});
  }
`;

export default CheckBox;
